import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const SummaryStatBar = ({ stats }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
    {stats.map(s => (
      <div key={s.label} className={`bg-white rounded-xl border shadow-sm p-4 flex flex-col gap-1.5 ${s.border || 'border-slate-200'}`}>
        {s.icon && (
          <div className={`w-7 h-7 rounded-lg flex items-center justify-center mb-0.5 ${s.iconColor || 'bg-blue-50 text-blue-600'}`}>
            <SafeIcon icon={s.icon} className="text-sm" />
          </div>
        )}
        <div className={`text-2xl font-bold ${s.valueColor || 'text-slate-800'}`}>{s.value}</div>
        <div className="text-xs font-medium text-slate-500 leading-snug">{s.label}</div>
      </div>
    ))}
  </div>
);

export default SummaryStatBar;